import { Flex, View, Image } from "@aws-amplify/ui-react"
import { useNavigate } from "react-router-dom"

export const CatalogPage = ({ language }) => {

    const groups = [
        {
            title: { "en": "Chest", "ru": "Грудь" },
            img: "/pictures/chest.jpg"
        },
        {
            title: { "en": "Back", "ru": "Спина" },
            img: "/pictures/back.png"
        },
        {
            title: { "en": "Shoulders", "ru": "Плечи" },
            img: "/pictures/shoulders.jpg"
        },
        {
            title: { "en": "Biceps", "ru": "Бицепс" },
            img: "/pictures/biceps.jpg"
        },
        {
            title: { "en": "Triceps", "ru": "Трицепс" },
            img: "/pictures/triceps.png"
        },
        {
            title: { "en": "Forearms", "ru": "Предплечье" },
            img: "/pictures/forearms.jpg"
        },
        {
            title: { "en": "Quads", "ru": "Квадрицепс" },
            img: "/pictures/quads.jpg"
        },
        {
            title: { "en": "Glutes", "ru": "Ягодицы" },
            img: "/pictures/glutes.png"
        },
        {
            title: { "en": "Hamstrings", "ru": "Бедро" },
            img: "/pictures/hamstrings.png"
        },
        {
            title: { "en": "Core", "ru": "Кор" },
            img: "/pictures/core.jpg"
        },
        {
            title: { "en": "Calves", "ru": "Икры" },
            img: "/pictures/calves.png"
        },

    ]
    const navigate = useNavigate()

    return (
        <div>
            <div className="my-2 mx-1 px-1 py-2" style={{ height: 'calc(100vh - 120px)' }} >
                <Flex
                    direction="row"
                    style={{ height: 'calc(100vh - 120px)', overflow: 'auto' }}
                    justifyContent="center"
                    alignItems="stretch"
                    alignContent="space-around"
                    wrap="wrap"
                    gap="0.5rem"
                >
                    {
                        groups.map((value, index) =>
                            <View
                                onClick={() => {
                                    navigate(`${value.title["en"].toLowerCase()}`)
                                }}
                                key={index}
                                className="catalog-group-view"
                                style={{
                                    minWidth: '10rem',
                                }}
                            >
                                <div className="d-flex flex-column">
                                    <Image
                                        src={value.img}
                                        style={{
                                            minHeight: '8rem',
                                            minWidth: '9rem'
                                        }}
                                    >

                                    </Image>

                                    <h5>{value.title[language]}</h5>

                                </div>
                            </View>)
                    }

                </Flex>
            </div>

        </div>
    )
}